<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="80px">
          <el-form-item label="产品编码">
            <el-input v-model.trim="searchForm.productCode" placeholder="请输入产品编码"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.trim="searchForm.productName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="A类价">
            <el-select v-model="searchForm.dailyRetailPrice" multiple collapse-tags filterable placeholder="请选择">
              <el-option :label="item.optionValue" :value="item.optionValue" v-for="item in optsList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否清仓">
            <el-select v-model="searchForm.clearance" placeholder="全部">
              <el-option label="全部" value="" />
              <el-option label="是" value="是" />
              <el-option label="否" value="否" />
            </el-select>
          </el-form-item>
          <el-form-item label="更新人">
            <el-input v-model.trim="searchForm.updatedBy" placeholder="请输入更新人"></el-input>
          </el-form-item>
          <el-form-item label="更新时间">
            <form-date-range :form="searchForm" startKey="startTime" endKey="endTime" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <!-- <el-button type="primary" size="mini" @click="importExcel">导入</el-button> -->
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table border :data="tableData" :height="maxTableHeight" v-loading="loading" :header-cell-style="{ backgroundColor: '#F4F8FB' }">
        <el-table-column :show-overflow-tooltip="true" label="产品编码" prop="productCode"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="产品名称" prop="productName"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="A类价系数" prop="dailyRetailPrice"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="调整原因" prop="reason"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="更新人员" prop="updatedBy"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="更新时间" prop="updatedDate"></el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="edit(scope.row)">编辑</el-link>
            <el-link type="primary" :underline="false" @click="see(scope.row)">查看调整记录</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageIndex"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <!-- 编辑弹窗 -->
    <edit-dialog :visible.sync="dialogVisible" :row="rowData" @success="init" v-if="dialogVisible" />

    <!-- 查看调整记录弹窗 -->
    <record-dialog :visible.sync="seeVisible" :row="seeRow" v-if="seeVisible" />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';
import EditDialog from './edit-dialog.vue';
import RecordDialog from './record-dialog.vue';

export default {
  name: 'PriceUphold',
  mixins: [pagePathMixin, tableMixin],
  components: { EditDialog, RecordDialog },
  data() {
    return {
      loading: false,
      searchForm: {
        productCode: '',
        productName: '',
        dailyRetailPrice: [],
        clearance: '',
        updatedBy: '',
        startTime: '',
        endTime: '',
      },
      optsList: [],
      tableData: [],
      page: {
        pageIndex: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      rowData: {},
      seeRow: {},
      seeVisible: false,
    };
  },
  mounted() {
    this.getOptions();
    this.init();
  },
  methods: {
    see(row) {
      this.seeRow = row;
      this.seeVisible = true;
    },
    handleSearch() {
      this.page.pageSize = 30;
      this.page.pageIndex = 1;
      this.init();
    },
    resetForm() {
      this.searchForm = {
        productCode: '',
        productName: '',
        dailyRetailPrice: [],
        clearance: '',
        updatedBy: '',
        startTime: '',
        endTime: '',
      };
      this.handleSearch();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.init();
    },
    init() {
      this.loading = true;
      let data = {
        exportTag: true,
        filterData: { ...this.searchForm },
        pageNum: this.page.pageIndex,
        pageSize: this.page.pageSize,
      };
      this.$q.product
        .productPriceCoefficientList({ data: data })
        .then((res) => {
          if (res.code == 200 && res.data.records) {
            this.tableData = res.data.records;
            this.page.total = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getOptions() {
      let data = {
        pageNum: 1,
        pageSize: 1000,
        filterData: {
          optionType: '30',
          tag: 3,
        },
      };
      this.$q.goods.listPage({ data }).then((res) => {
        this.optsList = res.data.records || [];
      });
    },
    edit(row) {
      this.rowData = row;
      this.dialogVisible = true;
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchForm,
        },
        reportName: 'productPriceCoefficientExport',
      };
      this.$q.orderDate
        .importExcel({ data: params })
        .then((res) => {
          if (res.success) {
            this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    // 导入
    importExcel() {
      this.openSubPage({
        path: '/dataImport/productPriceCoefficientImport',
        query: {
          fileName: '产品价格系数维护_模板.xlsx',
          appCode: 'ec-pc-api',
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right

.search-box
  >>> .el-select, >>> .el-input
    width 240px !important

>>> .date-range .single-date
  width 110px !important

.record-header
  padding-bottom 15px

.headerText
  display inline-block
  padding-right 50px
</style>
